import { z } from 'zod'

export const rejectPriceSurveySchema = z.object({
  rejection_reason: z.string().min(1, { message: 'Campo obrigatório' }),
})

export type RejectPriceSurveyValidationSchema = z.infer<typeof rejectPriceSurveySchema>
